
import { Component, DoCheck, EventEmitter, Injector, Input, OnChanges, OnInit, Output } from '@angular/core';
import { ApprovalWindowInEnum, ProjectTimeOffCreateOrEditDto, ProjectTimeOffGetAllDto, UserListDto, UserServiceProxy } from '@shared/service-proxies/service-proxies';
import { MessageService } from 'abp-ng2-module';
import { ProjectService } from '../../Services/project.service';
import { AppComponentBase } from '@shared/common/app-component-base';

@Component({
  standalone: false,
  selector: 'project-time-off-approval',
  templateUrl: './project-time-off-approval.component.html',
  styleUrls: ['./project-time-off-approval.component.scss']
})
export class ProjectTimeOffApprovalComponent extends AppComponentBase implements OnInit, OnChanges, DoCheck {

  @Input() projectTimeOffEdit: ProjectTimeOffGetAllDto;
  @Input() projectFormSubmitted: boolean = false;
  @Input() ProjectTeam: UserListDto[];
  @Output() onApproverType1event = new EventEmitter<ProjectTimeOffCreateOrEditDto>();
  @Output() dataChange = new EventEmitter<any>();

  constructor(injector:Injector,private _userServiceProxy: UserServiceProxy, 
              private _messageService: MessageService,
              public projectService: ProjectService) {super(injector);

               }
  ngAfterViewInit(): void {
      this.Level1Approver = this.projectTimeOffEdit?.approverLevelOne;
  }

  filterText="";
  displayLevel = 1;
  @Input() usersData:UserListDto[] = [];
  Level1Approver:UserListDto;
  Level2Approver: UserListDto;
  Level3Approver: UserListDto;
  Level4Approver: UserListDto;
  Level5Approver: UserListDto;

  level1ApprovalWindow: number = 1;
  level1ApprovalWindowEnum: ApprovalWindowInEnum = ApprovalWindowInEnum.Days;
  level2ApprovalWindow: number = 2;
  level2ApprovalWindowEnum: ApprovalWindowInEnum = ApprovalWindowInEnum.Days;
  level3ApprovalWindow: number = 3;
  level3ApprovalWindowEnum: ApprovalWindowInEnum = ApprovalWindowInEnum.Days;
    level4ApprovalWindow: number = 4;
    level4ApprovalWindowEnum: ApprovalWindowInEnum = ApprovalWindowInEnum.Days;
    level5ApprovalWindow: number = 5;
    level5ApprovalWindowEnum: ApprovalWindowInEnum = ApprovalWindowInEnum.Days;
  projectTimeOff:ProjectTimeOffCreateOrEditDto = new ProjectTimeOffCreateOrEditDto() ;
  filteredUsers: UserListDto[] = [];

  WindowEnum = [
    {id:1, name:this.l("Hours")},
    {id:2, name:this.l("Days")}
  ]
  dataChanged:boolean=false;

    ngOnInit(): void {
        this.getUsers();
        this.projectTimeOff.approvalWindowInOne = ApprovalWindowInEnum.Days;
        this.Level1Approver = new UserListDto();
        this.projectTimeOff= new ProjectTimeOffCreateOrEditDto();
    }
    ngOnChanges() {
        if (!this.dataChanged) {
           this.Level1Approver = this.projectTimeOffEdit?.approverLevelOne;
          this.projectTimeOff.approvalWindowOne = this.projectTimeOffEdit?.approvalWindowOne;
          this.projectTimeOff.approvalWindowInOne = this.projectTimeOffEdit?.approvalWindowInOne;

          this.Level2Approver = this.projectTimeOffEdit?.approverLevelTwo;
          this.projectTimeOff.approvalWindowTwo = this.projectTimeOffEdit?.approvalWindowTwo;
          this.projectTimeOff.approvalWindowInTwo = this.projectTimeOffEdit?.approvalWindowInTwo;

          this.Level3Approver = this.projectTimeOffEdit?.approverLevelThree;
          this.projectTimeOff.approvalWindowThree = this.projectTimeOffEdit?.approvalWindowThree;
          this.projectTimeOff.approvalWindowInThree = this.projectTimeOffEdit?.approvalWindowInThree;

          this.Level4Approver = this.projectTimeOffEdit?.approverLevelFour;
          this.projectTimeOff.approvalWindowFour = this.projectTimeOffEdit?.approvalWindowFour;
          this.projectTimeOff.approvalWindowInFour = this.projectTimeOffEdit?.approvalWindowInFour;

          this.Level5Approver = this.projectTimeOffEdit?.approverLevelFive;
          this.projectTimeOff.approvalWindowFive = this.projectTimeOffEdit?.approvalWindowFive;
          this.projectTimeOff.approvalWindowInFive = this.projectTimeOffEdit?.approvalWindowInFive;
      }
        
    }
  ngDoCheck(){
    this.getfilteredUsers();
  }
  
  getfilteredUsers() {
    this.filteredUsers = [];
    this.usersData.forEach(x => {
      this.ProjectTeam.forEach(y => {
        if (y.id === x.id) this.filteredUsers.push(x);
      })
    })

      const levelApprovers = [
          this.Level1Approver,
          this.Level2Approver,
          this.Level3Approver,
          this.Level4Approver,
          this.Level5Approver
      ];

      for (const levelApprover of levelApprovers) {
          if (levelApprover) {
              this.filteredUsers = this.filteredUsers.filter(
                  user => user.fullName !== levelApprover.fullName
              );
          }
      }

  }

  getUsers() {
        this._userServiceProxy
            .getUsers(
                this.filterText,
                undefined,
                undefined,
                undefined,
                undefined,
                false,
                undefined,
                undefined,
                undefined,
                undefined
            )
            .pipe()
            .subscribe((result) => {
                this.usersData = result.items;
                this.markForCheck();
            });
    }

  onlyNumberKey(event) {
    return event.charCode === 8 || event.charCode === 0 ? null : event.charCode >= 48 && event.charCode <= 57;
  }

    addAprroverLevel() {
        this.displayLevel++;
  }
    removeAprroverLevel() {
        this.displayLevel--;
  }

  SaveApprovers(){
    if(this.Level1Approver == null){
      this._messageService.error(this.l("PleaseSelectTimeOffApprover"))
      return; 
    }
  }

    emitdata() {
      
      this.dataChanged = true;
        if (!this.Level1Approver) {
            this.projectTimeOff = new ProjectTimeOffCreateOrEditDto();
            this.onApproverType1event.emit(this.projectTimeOff);
        }
   
        this.projectTimeOff.approverIdLevelOne = this.Level1Approver ? this.Level1Approver.id : undefined;
        this.projectTimeOff.approverIdLevelTwo = this.Level2Approver ? this.Level2Approver.id : undefined;
        this.projectTimeOff.approverIdLevelThree = this.Level3Approver ? this.Level3Approver.id : undefined;
        this.projectTimeOff.approverIdLevelFour = this.Level4Approver ? this.Level4Approver.id : undefined;
        this.projectTimeOff.approverIdLevelFive = this.Level5Approver ? this.Level5Approver.id : undefined;

        this.projectTimeOff.approvalWindowInOne = this.projectTimeOff.approvalWindowInOne ? this.projectTimeOff.approvalWindowInOne : null;
        this.projectTimeOff.approvalWindowInTwo = this.projectTimeOff.approvalWindowInTwo ? this.projectTimeOff.approvalWindowInTwo : null;
        this.projectTimeOff.approvalWindowInThree = this.projectTimeOff.approvalWindowInThree ? this.projectTimeOff.approvalWindowInThree : null;
        this.projectTimeOff.approvalWindowInFour = this.projectTimeOff.approvalWindowInFour ? this.projectTimeOff.approvalWindowInFour : null;
        this.projectTimeOff.approvalWindowInFive = this.projectTimeOff.approvalWindowInFive ? this.projectTimeOff.approvalWindowInFive : null;
        this.onApproverType1event.emit(this.projectTimeOff);
        this.dataChange.emit({ approver: this.Level1Approver, approvalWindow: this.projectTimeOff.approvalWindowOne, windowType: this.projectTimeOff.approvalWindowInOne })

    }
  getFullname(name:string, lastname:string){
    return name+" "+lastname;
    }

    checkDataForApproval() {
        switch (this.displayLevel) {
            case 1:
                return this.Level1Approver && this.projectTimeOff.approvalWindowInOne && this.projectTimeOff.approvalWindowOne;
            case 2:
                return this.Level2Approver && this.projectTimeOff.approvalWindowInTwo && this.projectTimeOff.approvalWindowTwo;
            case 3:
                return this.Level3Approver && this.projectTimeOff.approvalWindowInThree && this.projectTimeOff.approvalWindowThree;
            case 4:
                return this.Level4Approver && this.projectTimeOff.approvalWindowInFour && this.projectTimeOff.approvalWindowFour;
            case 5:
                return this.Level5Approver && this.projectTimeOff.approvalWindowInFive && this.projectTimeOff.approvalWindowFive;
            default:
                return false;
        }
    }

    filterLeaveApprovalList() {
        if (this.Level1Approver) !this.filteredUsers.find(x => x.id === this.Level1Approver?.id) ? this.Level1Approver = undefined : undefined;
        if (this.Level2Approver) !this.filteredUsers.find(x => x.id === this.Level2Approver?.id) ? this.Level2Approver = undefined : undefined;
        if (this.Level3Approver) !this.filteredUsers.find(x => x.id === this.Level3Approver?.id) ? this.Level3Approver = undefined : undefined;
        if (this.Level4Approver) !this.filteredUsers.find(x => x.id === this.Level4Approver?.id) ? this.Level4Approver = undefined : undefined;
        if (this.Level5Approver) !this.filteredUsers.find(x => x.id === this.Level5Approver?.id) ? this.Level5Approver = undefined : undefined;
    }

}
